import React from 'react';
import Header from './component/Header';
import PublicFooter from '../components/layout/PublicFooter';
import { Button, Section } from '../components/ui';

const NotFound = () => {
    return (
        <div style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
            <Header />
            <Section padding="tw-py-24 md:tw-py-32">
                <div className="tw-text-center tw-max-w-lg tw-mx-auto">
                    <div className="tw-text-8xl tw-font-bold tw-text-gray-200 tw-mb-4">404</div>
                    <h1 className="tw-text-4xl tw-text-gray-900 tw-m-0 tw-mb-3">Page not found</h1>
                    <p className="tw-text-lg tw-text-gray-500 tw-mb-8 tw-m-0">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                    <Button variant="primary" to="/" size="lg">
                        Go back home
                    </Button>
                </div>
            </Section>
            <PublicFooter />
        </div>
    );
};

export default NotFound;
